// Shared dashboard helpers + constants.
// Extracted from pages/Dashboard.jsx during the Feb 2026 decomposition.
import { useRef, useCallback } from "react";

// Half-hour time options (5:00 AM through 10:30 PM) used by the work-hours pickers.
export const TIME_OPTIONS = [];
for (let h = 5; h <= 22; h++) {
  for (let m = 0; m < 60; m += 30) {
    const hour = h + m / 60;
    const displayH = h > 12 ? h - 12 : h === 0 ? 12 : h;
    const ampm = h >= 12 ? "PM" : "AM";
    const label = `${displayH}:${m.toString().padStart(2, "0")} ${ampm}`;
    TIME_OPTIONS.push({ value: hour, label });
  }
}

// AOC (Administrator On Call) shift reminders shown in the AOC banner.
export const AOC_REMINDERS = [
  { time: "Before leaving", task: "Check in with Intake - any pending admissions?", priority: "high" },
  { time: "Before leaving", task: "Confirm night shift charge has your contact info", priority: "high" },
  { time: "Before leaving", task: "Review census and any high-risk patients", priority: "medium" },
  { time: "Evening", task: "Be available for calls from units", priority: "info" },
  { time: "If called", task: "Document all after-hours decisions", priority: "medium" },
];

// Convert a decimal hour (e.g. 9.5) to a display string (e.g. "9:30 AM").
export const formatHour = (hour) => {
  const h = Math.floor(hour);
  const m = Math.round((hour - h) * 60);
  const ampm = h >= 12 ? "PM" : "AM";
  const displayH = h > 12 ? h - 12 : h;
  return `${displayH}:${m.toString().padStart(2, "0")} ${ampm}`;
};

// Sound notification hook — generates short tones via the WebAudio API.
// Used by the Focus Timer for start / 5-min-warning / completion cues.
export const useSound = () => {
  const audioRef = useRef(null);

  const playSound = useCallback((type) => {
    if (!audioRef.current) {
      audioRef.current = new Audio();
    }
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    if (type === "start") {
      oscillator.frequency.value = 880;
      gainNode.gain.value = 0.3;
    } else if (type === "warning") {
      oscillator.frequency.value = 440;
      gainNode.gain.value = 0.4;
    } else if (type === "complete") {
      oscillator.frequency.value = 523.25;
      gainNode.gain.value = 0.3;
    }
    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.2);
  }, []);

  return { playSound };
};
